import { SupabaseUpdatePersonalNotificationPreferencesRepository } from '@/shared/infra/repositories'
import { makeSupabaseEdgeHttpClient } from '@/main/factories/http'
import type { UpdatePersonalNotificationPreferences } from '@/shared/domain'

export function makeUpdatePersonalNotificationPreferences(): UpdatePersonalNotificationPreferences {
  return new SupabaseUpdatePersonalNotificationPreferencesRepository(makeSupabaseEdgeHttpClient())
    .execute
}
